<template>
  <div>
    <div v-if="is_loading" class="loading"></div>
    <datatable
      title="Position Educations"
      @create="createEducation"
      @delete="deleteEducation"
      @edit_click="editClick"
      @set_default="setAsCompanyDefault"
      @delete_all="deleteAll"
      :unique_buttons="unique_buttons"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'position-educations',
  data () {
    return {
      is_loading: false,
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'education_institution',
          value: 'education_institution.name'
        },
        {
          name: 'education_degree',
          value: 'education_degree.name'
        },
        {
          name: 'education_course',
          value: 'education_course.name'
        },
        {
          name: 'grade',
          value: 'grade'
        },
        {
          name: 'with_honors',
          value: 'with_honors'
        }
      ],
      data: [],
      operations: [],
      unique_buttons: [
        {
          name: 'set_default',
          display_text: 'Set As The Company Default'
        },
        {
          name: 'delete_all',
          display_text: 'Delete All Educations'
        }
      ],
      position_id: this.$route.query.position_id,
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getPositionEducations({
          current_company_id: this.company_id,
          position_id: this.position_id
        })
        .then(response => {
          this.data = response
        })
    },
    setAsCompanyDefault () {
      this.is_loading = true
      this.$network_utils.getCompanyEducations({ current_company_id: this.company_id }).then(educations => {
        let delete_requests = []
        educations.map(company_education => {
          delete_requests.push(this.$network_utils.deleteCompanyEducation({ id: company_education.id, current_company_id: this.company_id }))
        })
        this.$network_utils.caller.axios.all(delete_requests).then(() => {
          this.postEducationsToCompany()
        })
      })
    },
    postEducationsToCompany () {
      let requests = []
      this.data.map(position_education => {
        requests.push(this.$network_utils.postCompanyEducation({
          current_company_id: this.company_id,
          with_honors: position_education.with_honors,
          grade: position_education.grade,
          education_course_id: position_education.education_course == undefined ? undefined : position_education.education_course.id,
          education_degree_id: position_education.education_degree == undefined ? undefined : position_education.education_degree.id,
          education_institution_id: position_education.education_institution == undefined ? undefined : position_education.education_institution.id
        }))
      })
      this.$network_utils.caller.axios.all(requests).then(() => {
        this.deleteAll()
      })
    },
    deleteAll () {
      this.is_loading = true
      let requests = []
      for (let i = 0; i < this.data.length; i++) {
        requests.push(this.$network_utils.deletePositionEducation({ id: this.data[i].id, position_id: this.position_id, current_company_id: this.company_id }))
      }
      this.$network_utils.caller.axios.all(requests).then(() => {
        this.$utils.emit('show_toast', { text: 'כל ה- educations נמחקו בהצלחה' })
        this.is_loading = false
      })
    },
    deleteEducation (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.education_institution.name,
        item_name: delete_data.education_institution.name,
        method: 'deletePositionEducation',
        method_params: { id: delete_data.id, position_id: this.position_id, current_company_id: this.company_id }
      })
    },
    createEducation () {
      this.create({ designator: 'position-educations-modal', component_name: 'CompanyEducationsForm', is_create: true, is_position: true, position_id: this.position_id, company_id: this.company_id, modal_title: 'Create new Education', position_status: this.$route.query.position_status })
    },
    editClick (data) {
      this.create({ designator: 'position-educations-modal', component_name: 'CompanyEducationsForm', data, is_position: true, position_id: this.position_id, company_id: this.company_id, modal_title: data.education_institution.name, position_status: this.$route.query.position_status })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped>
  .loading{
    margin-top: 30px;
    margin-left: 30px;
    margin-bottom: 30px;
  }
</style>
